const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Pobieranie zdjęć dla danej kategorii (publiczne - bez autoryzacji)
export const fetchImages = async (category) => {
  try {
    const response = await fetch(`${API_URL}/api/images/${category}`);
    const data = await response.json();
    
    if (data.success) {
      return data.images;
    }
    return [];
  } catch (error) {
    console.error(`Błąd pobierania zdjęć ${category}:`, error);
    return [];
  }
};

// Pobieranie najnowszego zdjęcia
export const fetchLatestImage = async (category) => {
  const images = await fetchImages(category);
  return images.length > 0 ? images[0] : null;
};

// Pobieranie wszystkich zdjęć (dla admina - z autoryzacją)
export const fetchImagesAdmin = async (category, token) => {
  try {
    const response = await fetch(`${API_URL}/api/upload/files/${category}`, {
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      },
    });
    
    const data = await response.json();
    return data.success ? data.files : [];
  } catch (error) {
    console.error(`Błąd pobierania zdjęć (admin):`, error);
    return [];
  }
};